import { useQuery } from '@tanstack/react-query';
import { KnowledgeArticleDto } from 'src/api/FiretrolApiClient';
import { knowledgeArticleApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

export type { KnowledgeArticleDto };

export function useKnowledgeArticle(id: number | undefined) {
  return useQuery({
    queryKey: queryKeys.knowledgeArticles.detail(id!),
    queryFn: ({ signal }) =>
      knowledgeArticleApiClient.get(id!, toCancelToken(signal)),
    enabled: id != null,
  });
}
